import NthcLogo from "../../assets/logos/nthclogo.png";
import './FooterStyles.css';

const Footer = () => {
    // const today = new Date();
    return (
        <footer className='footer'>
            <div className="top-image">
                <img src="/images/subsidiaries/commodities.png" alt='NTHC Logo' />
            </div>

            <div className='top'>
                <div className='item'>
                    <h1>Locate Us</h1>
                    <p>Head Office,</p>
                    <p>Agyaba Street – Asokwa, Kumasi</p>
                    <p>Near the Baba Yara Sports Stadium</p>
                    <p>Ashanti- Region, Ghana</p>
                    <p>West Africa</p>
                    <p>P.O Box KS 4749, Kumasi- Main</p>
                    <p>Ghana, West Africa</p>
                    <p>GPS:AK 187- 8546</p>
                </div>
                <div className='item'>
                    <h1>Email</h1>
                    <a href="mailto:info@nthc.com.gh">info@nthc.com.gh</a><br />
                </div>
                <div className='item'>
                    <h1>Telephone</h1>
                    <a href="tel:233302240241">233-302-225130</a><br />
                </div>
                <div className='item'>
                    <h1>Follow us on</h1>
                    <a target="_blank" rel='noreferrer' href='https://facebbok.com/nthc_gh'>
                        <i className='fab fa-facebook square'></i>
                    </a>
                    <a target="_blank" rel='noreferrer' href='https://instagram.com/nthc_gh'>
                        <i className='fa-brands fa-instagram-square'></i>
                    </a>
                    <a target="_blank" rel='noreferrer'  href="https://www.linkedin.com/company/nthc"><i className="fab fa-linkedin"></i></a>
                    <a target="_blank" rel='noreferrer' href='https://twitter.com/NTHC_GH'>
                        <i className='fa-brands fa-twitter-square'></i>
                    </a>                   
                </div>
            </div>
            <div className='bottom'>
                <div className='item'>
                    <h1>Our Associates</h1>
                    <a target="_blank" rel='noreferrer' href="https://securities.nthc.com.gh">NTHC Securities Ltd</a>
                    <a target="_blank" rel='noreferrer' href="https://registrars.nthc.com.gh">NTHC Registrars Ltd</a>
                    <a target="_blank" rel='noreferrer' href="https://trustees.nthc.com.gh">NTHC Trustees Ltd</a>
                    <a target="_blank" rel='noreferrer' href="https://asset-management.nthc.com.gh">NTHC Asset Management Ltd</a>
                    {/* <a target="_blank" rel='noreferrer' href="https://commodities.nthc.com.gh">NTHC Commodities Ltd</a> */}
                    {/* <a target="_blank" rel='noreferrer' href="https://properties.nthc.com.gh">NTHC Properties Ltd</a> */}
                    <a target="_blank" rel='noreferrer' href="https://nthcpghana.com/">NTHC Properties Ltd</a>
                </div>
                 <div className='item'>
                    <h1>Our Services</h1>
                    {/* <a href="/newsletters">Newsletters</a>
                    <a href="/articles">Articles</a>
                    <a href="/investment_calculator">Investment Calculator</a>
                    <a href="/gallery">Gallery</a> */}
                </div>
                <div className='item'>
                    <h1>Resources</h1>
                    <a href="/form_downloads">Forms Download</a>
                    <a href="/newsletters">Newsletters</a>
                    <a href="/investment_calculator">Investment Calculator</a>
                    <a href="/gallery">Photo Gallery</a>
                </div>
                <div className='item'>
                    <h1>Help</h1>
                    <a href="/jobs">Jobs</a>
                    <a href="/contact">Contact Us</a>
                    <a href="/faq">FAQs</a>
                </div>
            </div>
        </footer>
    )
}

export default Footer
